import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { NotificationItem as NotificationItemComponent } from "../Drawer/Drawers/Notifications";
import CloseIcon from "./img/close-icon.svg?react";
import NiceModal from "@ebay/nice-modal-react";
import {
  getNotificationTarget,
  parseCMSBold,
  parseDate,
  useSessionStorage,
} from "../../Helpers";
import {
  MESSAGE_REFETCH_INTERVAL,
  setMessageAsSeen,
} from "../../api/message";
import { useVisibleMessages } from "../../api/message/useVisibleMessages";
import { useTransition, animated, easings } from "@react-spring/web";

function NotificationItem({ onClose, style, ...props }) {
  return (
    <animated.div className="notfication-item-wrapper" style={style}>
      <NotificationItemComponent {...props} />
      <button className="btn-close" onClick={onClose}>
        <CloseIcon />
      </button>
    </animated.div>
  );
}

function NotificationGroup({ count, ...props }) {
  return (
    <NotificationItem
      {...props}
      title={`
    <small>Klicken, um</small>
    ${count} neue Benachrichtigungen zu sehen`}
      url
      unseen
    />
  );
}

export default function NotificationsPopper() {
  const [awardMissingPoints, setAwardMissingPoints] = useSessionStorage(
    "awardMissingPoints",
    ""
  );
  const [popupOpen, setPopupOpen] = useState({
    lastCount: 0,
    isOpen: false,
    localNotification: false,
  });

  // const awardAvailableCopy = {
  //   content: {
  //     title: "Nowy kupon do odebrania",
  //     description: `Masz wystarczającą liczbę punktów, aby odebrać teraz ${awardMissingPoints.awardName}`,
  //   },
  //   created: `${new Date().toISOString()}`,
  //   url: `/coupons/redeem/${awardMissingPoints.ident}`,
  // };

  const {
    listQuery: messageListQuery,
    messages,
    packPrizeMessage,
    count: visibleCount,
    isListLoaded,
  } = useVisibleMessages({
    refetchInterval: MESSAGE_REFETCH_INTERVAL,
  });

  const displayCount = isListLoaded ? visibleCount : undefined;

  const handledPrizesRef = useRef(new Set());

  useEffect(() => {
    if (!packPrizeMessage?.uuid) {
      return;
    }

    if (handledPrizesRef.current.has(packPrizeMessage.uuid)) {
      return;
    }
    handledPrizesRef.current.add(packPrizeMessage.uuid);

    NiceModal.show("qr-award-info-modal", {
      href: packPrizeMessage.prize?.uuid
        ? `/prize/redeem/${packPrizeMessage.prize.uuid}`
        : undefined,
    });

    setMessageAsSeen(packPrizeMessage.uuid, () => messageListQuery.refetch());
  }, [packPrizeMessage?.uuid]);

  useEffect(() => {
    if (displayCount === undefined) {
      return;
    }

    if (
      popupOpen.lastCount < displayCount &&
      !awardMissingPoints.showNotification
    ) {
      setPopupOpen({
        isOpen: true,
        lastCount: displayCount,
        localNotification: false,
      });
      return;
    }

    setPopupOpen((prev) => ({
      ...prev,
      lastCount: displayCount,
    }));
  }, [displayCount]);

  useEffect(() => {
    function checkLocalNotifications() {
      const sessionStorageData = JSON.parse(
        sessionStorage.getItem("awardMissingPoints")
      );

      if (
        Object.keys(sessionStorageData ?? {}).length !== 0 &&
        sessionStorageData.showNotification
      ) {
        setPopupOpen((prev) => ({
          ...prev,
          isOpen: true,
          localNotification: true,
        }));
        return;
      }
    }

    checkLocalNotifications();

    window.addEventListener("storage", checkLocalNotifications);

    return () => {
      window.removeEventListener("storage", checkLocalNotifications);
    };
  }, []);

  function closePopup(localNotification = false) {
    if (localNotification) {
      setPopupOpen((prev) => ({
        ...prev,
        isOpen: false,
        localNotification: false,
      }));
      setAwardMissingPoints({});

      return;
    }

    setPopupOpen((prev) => ({ ...prev, isOpen: false }));
  }

  const count = displayCount;

  const transitionPopup = useTransition(popupOpen.isOpen, {
    from: {
      scale: 0,
      opacity: 0,
    },
    enter: {
      opacity: 1,
      width: "358px",
      scale: 1,
    },
    leave: {
      scale: 0,
      opacity: 0,
    },
    config: {
      duration: 400,
    },
  });

  // if (popupOpen.localNotification) {
  //   const sessionStorageData = JSON.parse(
  //     sessionStorage.getItem("awardMissingPoints" ?? "")
  //   );

  //   const data = {
  //     content: {
  //       title: "Nowy kupon do odebrania",
  //       description: `Masz wystarczającą liczbę punktów, aby odebrać teraz ${sessionStorageData.awardName}`,
  //     },
  //     created: `${new Date().toISOString()}`,
  //     url: `/coupons/redeem/${sessionStorageData.ident}`,
  //   };

  //   return (
  //     <div className="notifications-popper-component">
  //       {transitionPopup(
  //         (style, item) =>
  //           item && (
  //             <NotificationItem
  //               title={data?.content?.title}
  //               desc={parseCMSBold(data?.content?.description)}
  //               date={parseDate(data?.created)}
  //               url={data?.url ?? false}
  //               hide={() => {
  //                 closePopup(true);
  //               }}
  //               onClose={() => {
  //                 closePopup(true);
  //               }}
  //               style={style}
  //               unseen
  //             />
  //           )
  //       )}
  //     </div>
  //   );
  // }

  // if (popupOpen.localNotification) {
  //   const data = awardAvailableCopy;

  //   return (
  //     <div className="notifications-popper-component">
  //       {transitionPopup(
  //         (style, item) =>
  //           item && (
  //             <NotificationItem
  //               title={data?.content?.title}
  //               desc={parseCMSBold(data?.content?.description)}
  //               date={parseDate(data?.created)}
  //               url={
  //                 data?.coupon?.uuid
  //                   ? `/coupons/received/${data?.coupon?.uuid}`
  //                   : data?.url || false
  //               }
  //               hide={() => {
  //                 closePopup(true);
  //               }}
  //               onClose={() => {
  //                 closePopup(true);
  //               }}
  //               style={style}
  //               unseen
  //             />
  //           )
  //       )}
  //     </div>
  //   );
  // }

  if (count === 1) {
    const data = messages[0];

    return (
      <div className="notifications-popper-component">
        {transitionPopup(
          (style, item) =>
            item && (
              <NotificationItem
                title={data?.content?.title}
                desc={parseCMSBold(data?.content?.description)}
                date={parseDate(data?.created)}
                url={getNotificationTarget(data)}
                hide={() => {
                  closePopup();
                  if (data?.uuid) {
                    setMessageAsSeen(data.uuid, () =>
                      messageListQuery.refetch()
                    );
                  }
                }}
                onClose={() => {
                  closePopup();
                  if (data?.uuid) {
                    setMessageAsSeen(data.uuid, () =>
                      messageListQuery.refetch()
                    );
                  }
                }}
                style={style}
                unseen
              />
            )
        )}
      </div>
    );
  }

  if (count > 1) {
    return (
      <div className="notifications-popper-component">
        {transitionPopup(
          (style, item) =>
            item && (
              <NotificationGroup
                hide={() => {
                  NiceModal.show("drawer-notifications");
                  closePopup();
                }}
                onClose={() => {
                  closePopup();
                }}
                count={count}
                date={parseDate(messages[messages.length - 1]?.created)}
                style={style}
              />
            )
        )}
      </div>
    );
  }
}
